export default class Artist {
  public id!: string;
  public name!: string;
  public description!: string;
  public imageURL!: string;
  public birthDate!: Date;
  public deathDate!: Date;
  public birthCity!: string;
  public deathCity!: string;
  public birthYear !: number;
  public deathYear !: number;
  public scale !: string[];
  public scaleYear !: number;
  public links !: string[];
}